import { __assign, __awaiter, __generator } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { getProfileCompletionStatus, updateProfile } from '../../../services/api/OnboardingServices';
var ProfileCompletion = function () {
    var searchParams = useSearchParams()[0];
    var location = useLocation();
    var navigate = useNavigate();
    var email = searchParams.get('email') || '';
    var _a = useState(null), requiredFields = _a[0], setRequiredFields = _a[1];
    var _b = useState({ name: '' }), formData = _b[0], setFormData = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var handleInputChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setFormData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
        });
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, updateProfile(__assign(__assign({}, formData), { email: email }))];
                case 2:
                    _a.sent();
                    navigate('/'); // Redirect to home page after completion
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var fetchProfileCompletionStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getProfileCompletionStatus(email)];
                case 1:
                    response = _a.sent();
                    setRequiredFields(response.data.requiredFields);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Error fetching required fields:', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (email) {
            fetchProfileCompletionStatus();
        }
    }, [email]);
    if (!requiredFields) {
        return _jsx("div", { children: "Loading..." });
    }
    return (_jsxs("div", { children: [_jsx("h2", { children: "Complete Your Profile" }), _jsxs("form", { onSubmit: handleSubmit, children: [requiredFields.name && (_jsxs("div", { children: [_jsx("label", { children: "Name:" }), _jsx("input", { type: "text", name: "name", value: formData.name, onChange: handleInputChange, required: true })] })), _jsx("button", { type: "submit", disabled: loading, children: loading ? 'Saving...' : 'Submit' })] })] }));
};
export default ProfileCompletion;
